import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Route,  BrowserRouter as Router, Switch } from 'react-router-dom'
import Models from './Models';
import Navigation from './Navigation';
import { Container } from 'react-bootstrap';
import Stock from './Stock';
import Events from './Events';
import Places from './Places';
import Street from './Street';
import People from './People';
import 'bootstrap/dist/css/bootstrap.min.css';
import S3Lightbox from './S3Lightbox';
import CanyonlandsNP from './CanyonlandsNP';
import BryceCanyons from './BryceCanyons';
import Zion from './Zion';
import NewYork from './NewYork';
import Badlands from './Badlands';
import GrandTeton from './GrandTeton';
import Yellowstone from './Yellowstone';

const routing = (
    <Router>
      <Container className='sm' fluid >
        <Navigation />
        <Switch>
          <Route exact path="/" component={App} />
          <Route path="/models" component={Models} />
          <Route path="/people" component={People} />
          <Route path="/street" component={Street} />
          <Route path="/places" component={Places} />
          <Route path="/events" component={Events} />
          <Route path="/stock" component={Stock} />
          <Route path="/s3" component={S3Lightbox} />
          <Route path="/NewYork" component={NewYork} />
          <Route path="/canyonlands" component={CanyonlandsNP} />
          <Route path="/bryce" component={BryceCanyons} />
          <Route path="/zion" component={Zion} />
          <Route path="/badlands" component={Badlands} />
          <Route path="/grandTeton" component={GrandTeton} />
          <Route path="/yellowstone" component={Yellowstone} />
          {/* <Route path="/contact" component={Contact} /> */}
          {/* <Route component={Notfound} /> */}
        </Switch>
      </Container>
    </Router>
)

ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
